/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Franchises_Meta_DescriptionInputs */

const id_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jelajahi semua game dalam waralaba ${i?.name} di Epic Games Store.`)
};

const ms_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Layari semua permainan dalam francais ${i?.name} di Epic Games Store.`)
};

const da_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gennemse alle spil i ${i?.name} franchisen på Epic Games Store.`)
};

const de_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Durchstöbern Sie alle Spiele der ${i?.name}-Franchise im Epic Games Store.`)
};

const en_us2_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Browse all games in the ${i?.name} franchise on the Epic Games Store.`)
};

const es_es2_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explora todos los juegos de la franquicia ${i?.name} en la Epic Games Store.`)
};

const es_mx2_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explora todos los juegos de la franquicia ${i?.name} en la Epic Games Store.`)
};

const fil_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mag-browse ng lahat ng laro sa ${i?.name} franchise sa Epic Games Store.`)
};

const fr_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parcourez tous les jeux de la franchise ${i?.name} sur l'Epic Games Store.`)
};

const it_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sfoglia tutti i giochi del franchise ${i?.name} sull'Epic Games Store.`)
};

const hu_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Böngéssz az összes játék között a ${i?.name} franchise-ban az Epic Games Store-ban.`)
};

const nl_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Blader door alle games in de ${i?.name}-franchise in de Epic Games Store.`)
};

const no_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bla gjennom alle spill i ${i?.name}-serien på Epic Games Store.`)
};

const pl_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przeglądaj wszystkie gry z franczyzy ${i?.name} w Epic Games Store.`)
};

const pt_br2_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Navegue por todos os jogos da franquia ${i?.name} no Epic Games Store.`)
};

const pt_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore todos os jogos da franquia ${i?.name} na Epic Games Store.`)
};

const ro_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explorează toate jocurile din franciza ${i?.name} pe Epic Games Store.`)
};

const fi_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selaa kaikki pelit sarjassa ${i?.name} Epic Games Storessa.`)
};

const sv_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bläddra bland alla spel i serien ${i?.name} i Epic Games Store.`)
};

const vi_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Duyệt tất cả game trong thương hiệu ${i?.name} trên Epic Games Store.`)
};

const tr_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki ${i?.name} serisindeki tüm oyunlara göz atın.`)
};

const cs_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Procházejte všechny hry ve franšíze ${i?.name} na Epic Games Store.`)
};

const bg_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Разгледайте всички игри във франчайз ${i?.name} в Epic Games Store.`)
};

const ru_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Просмотр всех игр франшизы ${i?.name} в Epic Games Store.`)
};

const uk_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перегляньте всі ігри франшизи ${i?.name} в Epic Games Store.`)
};

const ar_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تصفح جميع ألعاب سلسلة ${i?.name} في Epic Games Store.`)
};

const hi_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store पर ${i?.name} फ़्रैंचाइज़ी के सभी गेम ब्राउज़ करें।`)
};

const th_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เรียกดูเกมทั้งหมดในแฟรนไชส์ ${i?.name} บน Epic Games Store`)
};

const ja_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store で ${i?.name} フランチャイズのすべてのゲームを閲覧。`)
};

const zh_cn2_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在Epic游戏商城浏览 ${i?.name} 系列的所有游戏。`)
};

const zh_hant1_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在Epic遊戲商城瀏覽 ${i?.name} 系列的所有遊戲。`)
};

const ko_franchises_meta_description = /** @type {(inputs: Franchises_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store에서 ${i?.name} 프랜차이즈의 모든 게임을 둘러보세요.`)
};

/**
* | output |
* | --- |
* | "Browse all games in the {name} franchise on the Epic Games Store." |
*
* @param {Franchises_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_meta_description = /** @type {((inputs: Franchises_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_meta_description(inputs)
	if (locale === "ms") return ms_franchises_meta_description(inputs)
	if (locale === "da") return da_franchises_meta_description(inputs)
	if (locale === "de") return de_franchises_meta_description(inputs)
	if (locale === "en-US") return en_us2_franchises_meta_description(inputs)
	if (locale === "es-ES") return es_es2_franchises_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_franchises_meta_description(inputs)
	if (locale === "fil") return fil_franchises_meta_description(inputs)
	if (locale === "fr") return fr_franchises_meta_description(inputs)
	if (locale === "it") return it_franchises_meta_description(inputs)
	if (locale === "hu") return hu_franchises_meta_description(inputs)
	if (locale === "nl") return nl_franchises_meta_description(inputs)
	if (locale === "no") return no_franchises_meta_description(inputs)
	if (locale === "pl") return pl_franchises_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_meta_description(inputs)
	if (locale === "pt") return pt_franchises_meta_description(inputs)
	if (locale === "ro") return ro_franchises_meta_description(inputs)
	if (locale === "fi") return fi_franchises_meta_description(inputs)
	if (locale === "sv") return sv_franchises_meta_description(inputs)
	if (locale === "vi") return vi_franchises_meta_description(inputs)
	if (locale === "tr") return tr_franchises_meta_description(inputs)
	if (locale === "cs") return cs_franchises_meta_description(inputs)
	if (locale === "bg") return bg_franchises_meta_description(inputs)
	if (locale === "ru") return ru_franchises_meta_description(inputs)
	if (locale === "uk") return uk_franchises_meta_description(inputs)
	if (locale === "ar") return ar_franchises_meta_description(inputs)
	if (locale === "hi") return hi_franchises_meta_description(inputs)
	if (locale === "th") return th_franchises_meta_description(inputs)
	if (locale === "ja") return ja_franchises_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_meta_description(inputs)
	return ko_franchises_meta_description(inputs)
});
export { franchises_meta_description as "franchises.meta.description" }